module.exports = __webpack_public_path__ + "media/Components/fonts/boldRobotoSlab-067c5b8d28f17e0961cdc3a68058900e.ttf";